var _a;
import { hooksGenerator } from "../generic/all.hooks";
import CONFIG from "./templateDocument.config";
export var useDetail = (_a = hooksGenerator({
    entityName: CONFIG.ENTITY_NAME,
    resource: CONFIG.RESOURCE,
    getBaseState: function (state) { return state[CONFIG.REDUCER_KEY]; },
}), _a.useDetail), usePaged = _a.usePaged;
